module.exports = __webpack_public_path__ + "tax-free.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tax-free.svg
// module id = 483
// module chunks = 0